import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import React, { useEffect, useState } from 'react';
import useMyMApi from "../../hooks/useMyMApi";
import useWebContext from '../../hooks/useWebContext';
import { MyMProgress } from '../../ui-elements/MyMProgress';
import MetadataApliableFilterCard from '../../ui-parts/MetadataApliableFilterCard';
import NewsListResultCard from './NewsListResultCard';
import { mediaQuery, useMediaQuery } from '../../hooks/useMediaQuery';

/**
 * NewsList Page Component
 */
const NewsList = () => {
  // 変数・State
  const screenId = 'MyM501';
  const apiRequest = useMyMApi(screenId);
  const { controlSettings, messageList, screenSettings } = useWebContext(screenId);
  const [isLoading, setIsLoading] = useState(true);
  const [newsList, setNewsList] = useState(null);
  const [listPageNum, setListPageNum] = useState(1);
  const [metadataList, setMetadataList] = useState([]);
  const [apliableFilterList, setApliableFilterList] = useState([]);
  const [isInitLoaded, setIsInitLoaded] = useState(false);
  const [checkedList, setCheckedList] = useState([]);

  // 2024.9.16 MyMine Version2.0対応 Add Start
  const isPc = useMediaQuery(mediaQuery.pc);
  // 2024.9.16 MyMine Version2.0対応 Add End

  // ページロード時処理
  useEffect(() => {

    // パラメータ生成
    let parameter = `PageNumber=${listPageNum}&LimitMaxRowCount=${screenSettings.MaxRowCount}`;

    // APIコールバック成功時処理
    const callbackPageLoadSuccess = (result) => {
      setNewsList(result.HcmNewsList);
      setMetadataList(result.FilterList);
      setIsLoading(false);
    }
    // APIコールバック失敗時処理
    const callbackPageLoadFaild = (result) => {
      // 通信がエラーとなった場合ローディング状態を解除
      setIsLoading(false);
    }

    setIsLoading(true);
    // News一覧を取得する
    apiRequest.requestJson('api/news/news-list-load?' + parameter, 'GET', callbackPageLoadSuccess, callbackPageLoadFaild);
    setIsInitLoaded(true);
  }, []);

  /** フィルタ適用時 */
  useEffect(() => {
    if (isInitLoaded === false) { return; }
    if (listPageNum === 1) {
      requestSearch();
    } else {
      setListPageNum(1);
    }
  }, [apliableFilterList]);

  /** ページング切り替え時 */
  useEffect(() => {
    if (isInitLoaded === false) { return; }
    requestSearch();
  }, [listPageNum]);

  // リクエスト処理
  const requestSearch = () => {
    // APIコールバック成功時処理
    const callbackPageLoaddSuccess = (result) => {
      setIsLoading(false);
      setNewsList(result);
    }
    // APIコールバック失敗時処理
    const callbackPageLoadFaild = (result) => {
      // 通信がエラーとなった場合ローディング状態を解除
      setIsLoading(false);
    }

    // パラメータ生成
    const parameter = `PageNumber=${listPageNum}&LimitMaxRowCount=${screenSettings.MaxRowCount}&FilterMetadataIds=${apliableFilterList.join(',')}`;

    setIsLoading(true);
    // News一覧を取得する
    apiRequest.requestJson('api/news/news-list-page?' + parameter, 'GET', callbackPageLoaddSuccess, callbackPageLoadFaild)
  };

  if (newsList === null)
    return <MyMProgress />

  return (
    <Box className='pb-3'>
      <Grid container>
        { /* NewsList Area */}
        <Grid item xs={12} lg={9}>
          <NewsListResultCard
            screenId={screenId}
            apiRequest={apiRequest}
            controlSettings={controlSettings}
            messageList={messageList}
            newsList={newsList}
            listPageNum={listPageNum}
            setListPageNum={setListPageNum}
            setIsLoading={setIsLoading}
            isLoading={isLoading}
            setApliableFilterList={setApliableFilterList}
            isPc={isPc}
            metadataList={metadataList}
            checkedList={checkedList}
            setCheckedList={setCheckedList}
          />
        </Grid>
        { /* Filter Area */}
        {isPc &&
          <Grid item xs={12} lg={3}>
            <MetadataApliableFilterCard
              cardTitle={controlSettings.LabelList.lblFilterResultTitle}
              metadataList={metadataList}
              controlSettings={controlSettings}
              setApliableFilterList={setApliableFilterList}
              checkedList={checkedList}
              setCheckedList={setCheckedList}
            />
          </Grid>
        }
      </Grid>
    </Box>
  );
}
export default NewsList;
